// extracted by mini-css-extract-plugin
export var attachment = "_os-a";
export var emailContainer = "_os-4";
export var emailContentPaddedContainer = "_os-b";
export var emailHeader = "_os-6";
export var emailIframe = "_os-3";
export var emailInfoIcon = "_os-9";
export var emailShortenedSummary = "_os-e";
export var infoDropdown = "_os-0";
export var infoRowBoundedContent = "_os-d";
export var internal = "_os-5";
export var merchant = "_os-8";
export var messageInputContainer = "_os-h";
export var normal = "_os-7";
export var replyCard = "_os-f";
export var subtleButton = "_os-1";
export var subtleButtonIconContainer = "_os-2";
export var toggleViewRepliesButton = "_os-c";
export var wrappingText = "_os-g";